import React, {PropsWithChildren, useState} from 'react';

import {WorkdayCollapsibleTileHandle} from './WorkdayCollapsibleTileHandle';
import {IconNames} from '@atoms';

interface WorkdayCollapsibleTileProps extends PropsWithChildren {
  icon: IconNames;
  handle?: string | React.ReactNode;
  handleClassName?: string;
  contentClassName?: string;
  initialOpen?: boolean;
  toggleChevronOnPress?: boolean;
  disabled?: boolean;
  onPress?: () => void;
}

export const WorkdayCollapsibleTile = ({
  onPress,
  icon,
  handle,
  children,
  handleClassName,
  contentClassName,
  toggleChevronOnPress = false,
  disabled = false,
  initialOpen = false,
}: WorkdayCollapsibleTileProps) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const toggle = () => setIsOpen((prev) => !prev);

  const handlePress = () => {
    if (onPress) {
      if (toggleChevronOnPress) toggle();

      onPress();

      return;
    }

    toggle();
  };

  const renderHandle = () => {
    if (typeof handle === 'string') {
      return <p className="text-[15px]">{handle}</p>;
    }

    return handle;
  };

  return (
    <>
      <WorkdayCollapsibleTileHandle
        onClick={handlePress}
        isOpen={isOpen}
        isToggleable={!onPress || toggleChevronOnPress}
        icon={icon}
        disabled={disabled}
        className={`flex-1 ${handleClassName || ''}`}>
        {renderHandle()}
      </WorkdayCollapsibleTileHandle>

      {isOpen && children}
    </>
  );
};
